import axios from 'axios';
import { useState} from 'react'

const useDeleteWBody = () => {
    const [loading,setLoading] = useState(false);
    const [error,setError]  = useState(null);
    const [data,setData] = useState();
    const token = localStorage.getItem('token');

    const deleteItem = async (url,body) => {
        setLoading(true);
        setError(null);
        console.log("body" , body)

        try {
            const res = await axios.delete(url, body
              ,{
              headers:{
                  'Authorization': `Bearer ${token}` 
              }
          }
        );
            setData(res.data)

          // Handle successful deletion
        } catch (error) {
            setError(error);
          // Handle error
        } finally {
            setLoading(false);
        }
        };
        console.log('deleteItem' ,data)

    return {deleteItem,data,loading,error}
}

export default useDeleteWBody